import { useTranslation } from "react-i18next";
import SeoHead from "@/components/SeoHead";
import TermsPageContent from "./legal/TermsPageContent";
import PrivacyPageContent from "./legal/PrivacyPageContent";
import RefundPolicyContent from "./legal/RefundPolicyContent";
import { useLegalScrollReached } from "./legal/useLegalScrollReached";

/**
 * 合并版：App 首启门槛、登录后补同意等场景只需滚动一次到底。
 * 内嵌于 WebView / iframe 时父页监听 doc: "legal"。
 */
export default function LegalCombinedPage() {
  const { t } = useTranslation();
  useLegalScrollReached("legal");

  return (
    <div className="max-w-3xl mx-auto p-8 bg-white min-h-screen pb-32">
      <SeoHead
        path="legal"
        title="Legal - BamaBang"
        description="BamaBang legal documents: Terms of Service, Privacy Policy, and Refund & Cancellation Policy."
      />
      <p className="text-sm text-gray-600 mb-6 leading-relaxed">
        {t("legal.scroll_hint")}
      </p>

      <section className="border-b border-gray-200 pb-10 mb-10">
        <TermsPageContent />
      </section>

      <section className="border-b border-gray-200 pb-10 mb-10">
        <PrivacyPageContent />
      </section>

      <section>
        <RefundPolicyContent />
      </section>
    </div>
  );
}

